import Vue from "vue";
import {
  Button,
  Popup,
  Icon,
  Image as VanImage,
  Notify,
  Cell,
  List,
  NavBar,
  Loading,
  Tabbar,
  TabbarItem,
  Progress,
  Checkbox,
  Overlay,
  CellGroup,
  Lazyload,
  Dialog,
  RadioGroup,
  Radio
} from "vant";

export function initVantComponents() {
  Vue.use(Notify);
  Vue.use(Button);
  Vue.use(Icon);
  Vue.use(VanImage);
  Vue.use(Popup);
  Vue.use(Cell);
  Vue.use(List);
  Vue.use(NavBar);
  Vue.use(Loading);
  Vue.use(Tabbar);
  Vue.use(TabbarItem);
  Vue.use(Progress);
  Vue.use(Checkbox);
  Vue.use(Overlay);
  Vue.use(CellGroup);
  Vue.use(Lazyload);
  Vue.use(Dialog);
  Vue.use(Radio);
  Vue.use(RadioGroup);
}

const baseStyle = `padding: 2px; border-radius: 2px;color: white;`;

export function initDataRanger() {
  if (process.env.NODE_ENV === "development") {
    window.$event = (eve, param) => {
      // eslint-disable
      console.info(
        `%c record event %c ${eve} %c ${JSON.stringify(param)}`,
        `background: #996EFF; ${baseStyle}`,
        `background: green; ${baseStyle}; border-radius: 0`,
        `background: grey; ${baseStyle}`
      );
    };
  } else if (window.collectEvent) {
    window.$event = (eve, param) => {
      window.fbq && window.fbq("trackCustom", eve, param);
      window.collectEvent.call(null, eve, param);
    };
    window.$event("init", {
      app_id: 214234,
      channel: "sg",
      log: true
    });
    window.$event("start");
  } else {
    window.$event = () => {
      console.info("something is wrong !");
    };
  }
}
